import {
  TASK_CREATED_FOR_PAIR,
  TASK_DELETED_FOR_PAIR,
  TASK_UPDATED_FOR_PAIR,
} from '../../components/tasks/graphql.js'
import { useSubscription } from '../../api/useSubscription.js'

/**
 * Invisible component that owns the three pair-scoped subscriptions for a
 * single (reportId, managerId) pair.
 *
 * The Tasks page renders one of these per pair the user belongs to. This
 * is the only way to fan out N subscriptions in this codebase since the
 * `useSubscription` hook is per-call (rules of hooks forbid loop calls).
 */
export function PairSubscriber({
  reportId,
  managerId,
  enabled = true,
  onTaskCreated,
  onTaskUpdated,
  onTaskDeleted,
}) {
  useSubscription(
    TASK_CREATED_FOR_PAIR,
    { reportId, managerId },
    (data) => onTaskCreated?.(data?.taskCreatedForPair),
    { enabled: enabled && !!reportId && !!managerId },
  )
  useSubscription(
    TASK_UPDATED_FOR_PAIR,
    { reportId, managerId },
    (data) => onTaskUpdated?.(data?.taskUpdatedForPair),
    { enabled: enabled && !!reportId && !!managerId },
  )
  useSubscription(
    TASK_DELETED_FOR_PAIR,
    { reportId, managerId },
    (data) => onTaskDeleted?.(data?.taskDeletedForPair),
    { enabled: enabled && !!reportId && !!managerId },
  )
  return null
}
